import {
  richDetailsStateClosedClass,
  richDetailsStateOpenClass,
} from '#/components/RichDetails/richDetailsClasses';

import {
  richDetailsAttr,
  richDetailsDesktopTriggersOnHoverAttr,
  richDetailsSingletonAttr,
} from './rich-details.attributes';
import type { Snippet } from './types/Snippet';
import { isDesktop } from './utils/is-desktop';
import { trackClickedElement } from './utils/track-clicked-element';

function closeAllSingletonsExcept(target: Element) {
  document
    .querySelectorAll<HTMLDetailsElement>(
      `details[${richDetailsSingletonAttr}][open]`,
    )
    .forEach((details) => {
      if (!details.contains(target)) {
        // Wait just a little bit because when going from one dropdown to another,
        // closing the previous dropdown gives a flickering impression
        setTimeout(() => {
          // eslint-disable-next-line no-param-reassign
          details.open = false;
        }, 25);
      }
    });
}

export const richDetailsSnippet = {
  init() {
    document
      .querySelectorAll<HTMLDetailsElement>(`details[${richDetailsAttr}]`)
      .forEach((details) => {
        if (!details.open) details.classList.add(richDetailsStateClosedClass);
      });
  },

  click(el) {
    // This is handling for "on click outside"
    closeAllSingletonsExcept(el);
  },

  toggle(el) {
    const details = el.closest<HTMLDetailsElement>(
      `details[${richDetailsAttr}] `,
    );
    if (!details) return;

    if (details.open) {
      if (details.hasAttribute(richDetailsSingletonAttr)) {
        closeAllSingletonsExcept(details);
      }

      setTimeout(() => {
        details.classList.replace(
          richDetailsStateClosedClass,
          richDetailsStateOpenClass,
        );
      }, 10);

      trackClickedElement(details);
    } else {
      details.classList.add(richDetailsStateClosedClass);
      details.classList.remove(richDetailsStateOpenClass);
    }
  },
  pointerover(el) {
    if (!isDesktop()) return;

    const details = el.closest<HTMLDetailsElement>(
      `details[${richDetailsDesktopTriggersOnHoverAttr}]`,
    );
    if (!details) return;

    details.open = true;

    let leftTimeout: NodeJS.Timeout | undefined = undefined;

    const onMouseOver = () => {
      clearTimeout(leftTimeout);
    };

    const onMouseOut = () => {
      leftTimeout = setTimeout(() => {
        details.open = false;

        details.removeEventListener('mouseover', onMouseOver);
        details.removeEventListener('mouseout', onMouseOut);
      }, 200);
    };

    details.addEventListener('mouseover', onMouseOver);
    details.addEventListener('mouseout', onMouseOut);
  },
} satisfies Snippet;
